import { Directive, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { Rule, Field } from '@zhongruigroup/ngx-query';

import { SelectCondition, OptionProperty, getSelectConditionIdentity, ControlModelPropertyEnum } from '../types';
import { OptionService } from '../services/option.service';
import { finalize } from 'rxjs/operators';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dfSelectOptions]',
  exportAs: 'SelectOptionsDirective'
})
// ä¸æéé¡¹è·å
export class SelectOptionsDirective implements OnInit {
  @Input() globalData: any;
  @Input() rule: Rule;
  @Input() conditions: Array<SelectCondition>;

  /**
   * @description å è½½å®æ
   *
   * @memberof SelectOptionsDirective
   */
  @Output() loadComplete: EventEmitter<string> = new EventEmitter<string>();

  options: Array<{ label: string; value: string }> = [];

  constructor(private service: OptionService) {}

  ngOnInit(): void {
    this.getOptions();
  }

  getOptions() {
    const condition = this.getCondition();
    if (!condition) {
      return;
    }
    const optionName = ControlModelPropertyEnum.Option;
    if (!condition.model || !condition.model[optionName]) {
      return;
    }

    const properties = condition.model[optionName] as Array<OptionProperty>;
    if (!properties) {
      return;
    }

    this.service
      .getSelectOptions(properties, this.globalData)
      .pipe(
        finalize(() => {
          this.loadComplete.emit(getSelectConditionIdentity(condition));
        })
      )
      .subscribe((s) => {
        this.options = s.map((v) => {
          return { label: v.text, value: v.id };
        });
      });
  }

  getCondition(): SelectCondition {
    const filedName = typeof this.rule.field === `string` ? this.rule.field : (this.rule.field as Field).name;
    return this.conditions.find((s) => getSelectConditionIdentity(s) === filedName);
  }
}
